import { render, staticRenderFns } from "./BasePriceInput.vue?vue&type=template&id=72fe36ee&scoped=true"
import script from "./BasePriceInput.vue?vue&type=script&lang=js"
export * from "./BasePriceInput.vue?vue&type=script&lang=js"
import style0 from "./BasePriceInput.vue?vue&type=style&index=0&id=72fe36ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe36ee",
  null
  
)

export default component.exports